var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blackout",class:{blocked: _vm.blocked, show: _vm.show}},[_c('div',{staticClass:"content vertical-align"},[_c('h1',[_vm._v("Well, that wasn't meant to happen!")]),_c('hr'),_c('p',[_vm._v("Sorry, but it looks like we've run into a problem.")]),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }